import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { browserHistory } from "react-router";
import _ from 'lodash';

import ProfileArea from '../components/ProfileArea';
import { INSTRUCTOR } from "../constants/roles";
import {
    ASSIGNMENTS__REQUESTED,
    DROPBOXES__REQUESTED,
    DROPBOXES__ROLES__REQUESTED,
    DROPBOX__USERS__REQUESTED,
    DROPBOX__USER__MEMBERSHIPS__REQUESTED,
    DROPBOX__USER__SUBMISSIONS__REQUESTED,
    ROLES__SELF__REQUESTED
} from "../constants/actionTypes";
import NavLink from "../components/NavLink";
import NavBar from "../components/NavBar";
import { getMappedKeyEntities } from "../helpers/helpers";

class ProfilePage extends AuthorizedComponent {
    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED,
        });
    }

    componentDidUpdate(prevProps) {
        const { assignments, dispatch, dropboxes, memberships, params, roles_self, submissions, users } = this.props,
            dropboxId = parseInt(params.dropboxId),
            userId = parseInt(params.userId)
        ;

        if (prevProps.roles_self !== roles_self) {
             const hasInstructorRole = _.includes(
                _.flatMap(
                    roles_self,
                    dropbox_role => {
                        if (dropbox_role.dropbox.id === dropboxId) {
                            return dropbox_role.role;
                        }
                    }),
                INSTRUCTOR
            );

            if (hasInstructorRole) {
                if (_.size(assignments) < 1) {
                    dispatch({
                        type: ASSIGNMENTS__REQUESTED,
                    });
                }

                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED,
                    });
                }

                if (users.dropbox !== dropboxId) {
                    dispatch({
                        type: DROPBOXES__ROLES__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                        },
                    });

                    dispatch({
                        type: DROPBOX__USERS__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                        },
                    });
                }

                if (memberships.dropbox !== dropboxId || memberships.user !== userId) {
                    dispatch({
                        type: DROPBOX__USER__MEMBERSHIPS__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                            userId: userId,
                        },
                    });
                }

                if (submissions.dropbox !== dropboxId || submissions.user !== userId) {
                    dispatch({
                        type: DROPBOX__USER__SUBMISSIONS__REQUESTED,
                        payload: {
                            dropboxId: dropboxId,
                            userId: userId,
                        },
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    render() {
        const { sendingRequest, inProgress } = this.props.request,
            isLoading = (
                _.includes(inProgress, 'assignments.doRequestAssignments') ||
                _.includes(inProgress, 'dropboxes.doRequestDropboxes') ||
                _.includes(inProgress, 'memberships.doRequestDropboxUserMemberships') ||
                _.includes(inProgress, 'roles.doRequestRolesSelf') ||
                _.includes(inProgress, 'roles.doRequestDropboxRoles') ||
                _.includes(inProgress, 'submissions.doRequestDropboxUserSubmissions') ||
                _.includes(inProgress, 'users.doRequestDropboxUsers')
            )
        ;

        if (sendingRequest && isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { assignments, dropboxes, memberships, params, roles, submissions, users } = this.props,
            user = users[params.userId],
            dropbox = dropboxes[params.dropboxId]
        ;

        return assignments && dropbox && submissions && users
            ? (
                <div className="col-md-12">
                    <div className={"action-links"}>
                        <NavBar
                            className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                            display
                        >
                            <NavLink
                                to={`/dropbox/${dropbox.id}/users`}
                                className="btn btn-outline-primary btn-md"
                                side="left"
                                display
                                key="enrollment"
                            >
                                Exit To Enrollment <i className={"fa fa-chevron-circle-left"}/>
                            </NavLink>
                        </NavBar>
                    </div>
                    <h3>{dropbox.name}</h3>
                    <ProfileArea
                        assignments={assignments}
                        dropbox={dropbox}
                        memberships={getMappedKeyEntities(memberships)}
                        submissions={getMappedKeyEntities(submissions, 'id', 'string')}
                        roles={roles}
                        user={user}
                    />
                </div>
            ) : null
        ;
    }
}

ProfilePage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { assignments, auth, dropboxes, memberships, request, roles, roles_self, submissions, users } = state;

    return { assignments, auth, dropboxes, memberships, request, roles, roles_self, submissions, users };
}

export default connect(mapStateToProps)(ProfilePage);



/** WEBPACK FOOTER **
 ** ./src/containers/ProfilePage.js
 **/